import type { SearchViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import { useGetProductListPartial } from 'components/shared/productList/shared/hooks/useGetProductListPartialQuery';
import ProductListWithFilters from 'components/shared/productList/ProductListWithFilters';
import TrackingContext from 'modules/tracking/GA4/helpers/TrackingContext';
import SearchPageHeader from './components/SearchPageHeader';
import { SearchTextContext } from './hooks/contexts';

export default function SearchPage({ model }: { model: SearchViewModel }) {
    const { productListPartial, searchModel } = model;
    const { data: productListPartialModel } = useGetProductListPartial(productListPartial);

    return (
        <TrackingContext context="search">
            <Layout.Page>
                {/* Page Header */}
                <SearchPageHeader model={searchModel} />

                <Layout.Flex.Column gap="0">
                    {/* Product List with filters  */}
                    <Layout.Section>
                        <ProductListWithFilters model={productListPartialModel} />
                    </Layout.Section>
                </Layout.Flex.Column>
            </Layout.Page>

            {/* Recommendation */}
            {/* {searchResultRecommendationRequest && (
                <Layout.Section>
                    <RecommendationLoader model={searchResultRecommendationRequest} />
                </Layout.Section>
            )} */}
        </TrackingContext>
    );
}
